import React from "react";

const DownloadAppOverlay = ({ data }: { data: any }) => {
  if (!data || Object.keys(data).length === 0) return null;

  return (
    <div className="absolute inset-0 w-full z-[999] backdrop-blur-sm ">
      <div className="body-fluid m-0 absolute h-full w-full bg-black/80 backdrop-blur-sm flex justify-center items-center z-[999]">
        <div className="absolute w-full h-full flex flex-col justify-between">
          <a href={data.href} className="p-4 text-left my-auto">
            <div className="flex gap-2">
              <div className="text-xs sm:text-2xl text-white font-bold flex gap-2">
                {data.title}
              </div>
            </div>

            <div className="text-[10px] sm:text-base text-white mt-2 flex justify-between pl-4 pr-2">
              <ul
                className="list-disc basis-3/5 sm:space-y-2"
                dangerouslySetInnerHTML={{ __html: data.innerHTML }}
              />
              <img
                className="self-end basis-1/4 sm:basis-1/5"
                src={data.sectionImgSrc}
                alt="Section"
              />
            </div>

            <div className="border border-transparent pt-1 border-t-gray-500 mt-1 flex justify-between gap-4 items-center">
              <div className="flex gap-2">
                <img className="sm:w-9" src={data.src} alt="Logo" />
                <div className="flex flex-col text-xs sm:text-sm font-bold text-white">
                  {data.bottomTitle}
                  <img
                    className="sm:w-20"
                    src={data.ratingSrc ?? "https://static.doubtnut.com/images/review.svg"}
                    alt="Rating"
                  />
                </div>
              </div>
              <div>
                <div className="btn btn-primary sm:text-sm font-bold text-[10px] py-2 px-3.5">
                  {data.buttonText ?? "Download"}
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default DownloadAppOverlay;
